import SimpleAnnotation from './SimpleAnnotation';

export default SimpleAnnotation;
